import { Column } from '../../hooks/useTablePages';
import { format, parseISO } from 'date-fns';
import Icon from '../Icon/Icon';
import React from 'react';
import { Flex } from 'rebass';

const columns: Column[] = [
  {
    header: 'Gauge Number',
    id: 'gaugeNumber',
    accessor: (row) => (
      <Flex flexDirection="row" alignItems="center" sx={{ gap: 1 }}>
        {row.gaugeNumber}
        {row.image && (
          <Icon title={row.image.contentType} icon="file" size="16" />
        )}
      </Flex>
    ),
    stringAccessor: (row) => row.gaugeNumber,
    width: 140,
  },
  {
    header: 'Calibration Date',
    id: 'calibrationDate',
    accessor: (row) => {
      if (!row.calibrationDate) {
        return '';
      }
      return format(parseISO(row.calibrationDate), 'MMM d yyyy');
    },
    width: 130,
  },
  {
    header: 'Default',
    id: 'default',
    accessor: (row: any) => {
      switch (row.isDefault) {
        case true:
          return 'Yes';
        case false:
          return 'No';
        default:
          return 'N/A';
      }
    },
    width: 70,
  },
];

export default columns;

// Should this move to the Gauges directory?
